// extracted by mini-css-extract-plugin
export default {"maximizedHidden":"Common_maximizedHidden__1C6Hp","maximizedBaseForm":"Common_maximizedBaseForm__IG2cp","maximizedFooter":"Common_maximizedFooter__CnbmI"};